import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import { Info } from '@everlane/icon'
import classNames from 'classnames'
import RouterLink from 'base/components/router_link'
import Indicator from './indicator'

export default function List({ notifications, shouldShowIndicator, className, itemClassName }) {
  return (
    <div className={classNames('notifications__list', className)}>
      {notifications.map(notification => (
        <div
          className={classNames(
            'notifications__notification',
            `notifications__notification--${notification.variant}`,
            itemClassName,
          )}
          key={notification.message}
          onClick={() => notification.onClick?.()}
        >
          {shouldShowIndicator && <Indicator notifications={notifications} isInline />}

          {notification.submessage_link ? (
            <RouterLink href={notification.submessage_link} className="notifications__link">
              {notification.message}

              {notification.submessage && (
                <Fragment>
                  <br />
                  <span className="notifications__submessage">{notification.submessage}</span>
                </Fragment>
              )}
              {notification.shouldShowInfoIcon && <Info className="notifications__info-icon" />}
            </RouterLink>
          ) : (
            <Fragment>
              {notification.message}

              {notification.submessage && (
                <Fragment>
                  <br />
                  <span className="notifications__submessage">{notification.submessage}</span>
                </Fragment>
              )}
            </Fragment>
          )}
        </div>
      ))}
    </div>
  )
}

List.propTypes = {
  notifications: PropTypes.arrayOf(PropTypes.object),
}
